import Vue from "vue";

const state = {};

const getters = {};

const actions = {
    async getTableauViews(context) {
        const response = await Vue.http.get("/pando/analytics/tableau/getviews").catch(err => err.response);
        return response;
    },
    async refreshTableauViews(context) {
        const response = await Vue.http.get("/pando/analytics/tableau/refreshviews").catch(err => err.response);
        return response;
    },
    async updateTableauView(context, requestPackage) {
        const response = await Vue.http.post(`/pando/analytics/tableau/${requestPackage.Id}/updateview`, requestPackage).catch(err => err.response);
        return response;
    },
    async migrateTableauViewFavorites(context, requestPackage) {
        const response = await Vue.http.post(`/pando/analytics/tableau/${requestPackage.oldViewId}/migratefavorites/${requestPackage.newViewId}`).catch(err => err.response);
        return response;
    }
};

const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Tableau.js